
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Rumi Hai </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm summer-camp section-banner-bg-1">
    <div class="container">
        <div class="row text-justify">
            <div class="widget_title inner-title">
                <h4 class="fw-bold">Ashwin Chitale</h4>
            </div>
            <div class="col-md-8">
                <p>The show is created and performed by Ashwin Chitale, who discovered the beauty of Farsi through
                    its incomparable literature. Ashwin has been learning the Persian language for over four years now.
                    To develop his language skills beyond the scope of his language course, he started studying Persian
                    literature and discovered a deep love for Farsi poetry and storytelling.
                </p>
                <p>He also holds a Master’s degree in philosophy, which helped him gain a deeper understanding of
                    Persian philosophy and the way of life as depicted through its literature. Ashwin has won the
                    National Award for Best Child Artist for his debut Marathi film “Shwas” in 2004. Having a background
                    in Performing arts and the Persian language inspired him to create a performance that showcases
                    the beauty of this language through the poetry and philosophy of Maulana Rumi, who is regarded as
                    one of the most iconic Farsi writers of all time.
                </p>
            </div>
            <div class="col-md-4">
                <div class="image-effect-2">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rumi5.webp" alt="GHRSCF"
                        class="w-100">
                </div>
            </div>
            <div class="col-md-12">
                <div class="widget_title inner-title">
                    <h4 class="fw-bold">About Rumi Hai</h4>
                </div>
                <p>Through our program ‘Rumi Hai’, we wish to bring to light these underappreciated gems of Rumi
                    which have gotten lost in the fame of his more famous works. The program is an hour-long
                    biographical glimpse through “Naqqali” into the life of Rumi, his inspiration for writing, and his
                    signature philosophy on life’s many conundrums. The program will be helmed by a “Naqqali” telling
                    his life story through his own original ghazals, recited in both, the Persian language that it was
                    originally written in, followed by a Hindi-Urdu translation as well.
                <p>
                <p><b>Let’s meet you then.</b></p>
                <p><b>Performer – Ashwin Chitale</b></p>
                <p><b>Topic: Topic: Rumi Hai </b></p>
                <p><b>Date – 30<sup>th</sup> July 2022, Saturday </b></p>
                <p><b>Time –6:30 pm</b></p>
                <p><b>Venue: Tamarind Hall, Chitnavis Centre, Nagpur</b></p>
            </div>
        </div>
        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-md-6">
                <div class="gall-ery">
                    <div class="widget_title inner-title gall-sys shadow-text-sm">
                        <h4 class="fw-bold">Video</h4>
                    </div>
                    <!-- <a href="media.php#media_classical" class="v-more">View More</a> -->
                    <iframe width="100%" height="233" src="https://www.youtube.com/embed/nhOjuXBPwiI"
                        title="'Rumi Hai' is a biographical glimpse through “Naqqali” into the life of Rumi by Ashwin Chitale"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                </div>
            </div>
            <div class="col-md-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="photogallery#rumi-hai" class="btn button--effect-1"><span>
                                    View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai1.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai1.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai1.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai2.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai2.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai2.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai3.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai3.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai3.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai4.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai4.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai4.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai5.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai5.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai5.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai6.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai6.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai6.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>


                        </ul>
                    </div>
                </div>
                <!-- <div class="d-flex justify-content-between">
					<h3>Photos</h3>
					<a href="photogallery#rumi-hai" class="v-more">View More</a>
				</div>
				<div class="tz-gallery">
					<div class="row">
						<div class="col-sm-4 col-md-4 col-xs-6">
							<a class="lightbox" href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai1.jpg">
								<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai1.jpg" alt="rumi-hai">
							</a>
						</div>
						<div class="col-sm-4 col-md-4 col-xs-6">
							<a class="lightbox" href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai2.jpg">
								<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai2.jpg" alt="rumi-hai">
							</a>
						</div>
						<div class="col-sm-4 col-md-4 col-xs-6">
							<a class="lightbox" href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai3.jpg">
								<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai3.jpg" alt="rumi-hai">
							</a>
						</div>
						<div class="col-sm-4 col-md-4 col-xs-6">
							<a class="lightbox" href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai4.jpg">
								<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai4.jpg" alt="rumi-hai">
							</a>
						</div>
						<div class="col-sm-4 col-md-4 col-xs-6">
							<a class="lightbox" href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai5.jpg">
								<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai5.jpg" alt="rumi-hai">
							</a>
						</div>
						<div class="col-sm-4 col-md-4 col-xs-6">
							<a class="lightbox" href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai6.jpg">
								<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai6.jpg" alt="rumi-hai">
							</a>
						</div>

					</div>
				</div> -->
            </div>
        </div>
    </div>
</section>
